import React, { useEffect, useState } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import {
  GET_LOADING_POINTS_ENDPOINT,
  SAVE_LOADING_POINT_ENDPOINT,
  UPDATE_LOADING_POINT_ENDPOINT,
  DELETE_LOADING_POINT_ENDPOINT
} from '../../config/api';
import { decryptData } from '../../utils/encrypt';

function LoadingPointList() {
  const [orgId, setOrgId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [records, setRecords] = useState([]);
  const [editMap, setEditMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [newPointName, setNewPointName] = useState('');

  useEffect(() => {
    const encrypted = localStorage.getItem('suyog_user');
    if (encrypted) {
      const parsed = decryptData(encrypted);
      setOrgId(parsed?.selected_org?.value || null);
      setUserId(parsed?.user_id || null);
    }
  }, []);

  useEffect(() => {
    if (orgId) fetchData();
  }, [orgId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(GET_LOADING_POINTS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ org_id: orgId })
      });
      const data = await res.json();
      if (data.success) setRecords(data.records);
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (id, value) => {
    setEditMap((prev) => ({ ...prev, [id]: value }));
  };

  const handleUpdate = async (id) => {
    const name = editMap[id];
    if (!name || !userId) {
      alert('Name is required.');
      return;
    }

    const res = await fetch(UPDATE_LOADING_POINT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, name, user_id: userId })
    });
    const data = await res.json();
    if (data.success) {
      alert('Updated successfully');
      fetchData();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete?')) return;
    const res = await fetch(DELETE_LOADING_POINT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, user_id: userId })
    });
    const data = await res.json();
    if (data.success) {
      alert('Deleted successfully');
      fetchData();
    }
  };

  const handleAddNew = async () => {
    if (!newPointName || !userId || !orgId) {
      alert('Please enter loading point name.');
      return;
    }

    const res = await fetch(SAVE_LOADING_POINT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: newPointName, user_id: userId, org_id: orgId })
    });
    const data = await res.json();
    if (data.success) {
      alert('Loading point added.');
      setNewPointName('');
      fetchData();
    } else {
      alert('Failed to save. Try again.');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h3 className="mb-3">Loading Point List</h3>

        {/* Add new */}
        <div className="row mb-4">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Enter new loading point name"
              value={newPointName}
              onChange={(e) => setNewPointName(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button type="button" className="btn btn-primary" onClick={handleAddNew}>
              Add
            </button>
          </div>
        </div>

        {/* List Table */}
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {records.map((rec, index) => (
                  <tr key={rec.id}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        className="form-control"
                        value={editMap[rec.id] ?? rec.name}
                        onChange={(e) => handleChange(rec.id, e.target.value)}
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-success btn-sm me-2"
                        onClick={() => handleUpdate(rec.id)}
                      >
                        Update
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(rec.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default LoadingPointList;
